import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { customTheme } from './theme/theme';
import { BannersProvider } from './context/banners';
import { ModalProvider } from './context/modal';
import { AppLayout } from './components/ui/layout/app-layout';
import { GlobalBannerModal } from './components/asset-modal/global-banner-modal';
import { FormProvider } from './context/form';
import { ProtectedRoute } from './components/routing/protected-route';
import { SettingsProvider } from './context/settings';
import { useAuthContext } from './context/auth';
import { CreativityEditorPage } from './modules/creativity-editor';
import { AvatarsPage } from './modules/avatars/avatars-page';
import { AvatarsEditorPage } from './modules/avatars/avatars-editor-page';
import { loadBrandAssetsForClient } from './handlers/brand-assets';

const App: React.FC = () => {
  const { isLoggedIn, userInfo } = useAuthContext();

  const clientId = userInfo?.['custom:clientId'];
  React.useEffect(() => {
    loadBrandAssetsForClient(clientId);
  }, [clientId]);

  return (
    <BrowserRouter>
      <ConfigProvider theme={customTheme}>
        {isLoggedIn ? (
          <SettingsProvider>
            <ModalProvider>
              <BannersProvider>
                <FormProvider>
                  <div className='App'>
                    <Routes>
                      <Route path='/' element={<AppLayout />} />

                      <Route
                        path='/create-asset'
                        element={
                          <ProtectedRoute requiresBannerCreation={true}>
                            <AppLayout />
                          </ProtectedRoute>
                        }
                      />

                      <Route path='/library/*' element={<AppLayout />} />

                      {/* Vistas de amplificación por marca (datos de Social, scopeados a la marca logueada) */}
                      <Route path='/social-admin' element={<AppLayout />} />
                      <Route path='/social-admin/user/:openId' element={<AppLayout />} />

                      <Route
                        path='/creativity-form/:creativityType'
                        element={
                          <ProtectedRoute requiresBannerCreation={true}>
                            <AppLayout />
                          </ProtectedRoute>
                        }
                      />

                      <Route
                        path='/editor'
                        element={
                          <ProtectedRoute requiresBannerCreation={false}>
                            <CreativityEditorPage />
                          </ProtectedRoute>
                        }
                      />

                      <Route
                        path='/avatars-editor/:projectId'
                        element={
                          <ProtectedRoute requiresModule='digital-brand-ambassador'>
                            <AvatarsEditorPage />
                          </ProtectedRoute>
                        }
                      />

                      <Route
                        path='/creativity-editor/:creativityType'
                        element={
                          <ProtectedRoute requiresBannerCreation={true}>
                            <AppLayout />
                          </ProtectedRoute>
                        }
                      />

                      <Route
                        path='/creativity-editor/:creativityType/:contentId'
                        element={
                          <ProtectedRoute requiresBannerCreation={true}>
                            <AppLayout />
                          </ProtectedRoute>
                        }
                      />

                      <Route
                        path='/avatar-video'
                        element={
                          <ProtectedRoute requiresModule='digital-brand-ambassador'>
                            <AvatarsPage />
                          </ProtectedRoute>
                        }
                      />

                      <Route path='*' element={<Navigate to='/' replace />} />
                    </Routes>
                    <GlobalBannerModal />
                  </div>
                </FormProvider>
              </BannersProvider>
            </ModalProvider>
          </SettingsProvider>
        ) : (
          <div className='App'>
            <Routes>
              <Route path='*' element={<AppLayout />} />
            </Routes>
          </div>
        )}
      </ConfigProvider>
    </BrowserRouter>
  );
};

export default App;
